var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSberIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8381_67674)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7682 4.46631C17.1863 5.0142 17.5403 5.60943 17.823 6.24006L9.80467 12.2303L6.45361 10.1014V7.54024L9.80467 9.66915L16.7682 4.46631Z",
    fill: "#21A038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.0336 9.92075C3.0336 9.80582 3.03637 9.69166 3.0419 9.57815L1.01106 9.47729C1.00415 9.6244 1 9.77293 1 9.92282C0.999138 11.094 1.22645 12.2538 1.6689 13.3357C2.11134 14.4177 2.76021 15.4004 3.57829 16.2276L5.01882 14.7684C4.38909 14.1328 3.88952 13.3773 3.54883 12.5454C3.20814 11.7134 3.03305 10.8215 3.0336 9.92075Z",
    fill: "url(#paint0_linear_8381_67674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80281 3.06055C9.91615 3.06055 10.0288 3.06475 10.1408 3.07036L10.2424 1.01149C10.0968 1.00449 9.95024 1.00098 9.80281 1.00098C8.64661 0.999554 7.50159 1.22959 6.4334 1.67788C5.36521 2.12617 4.39492 2.78389 3.57825 3.61328L5.01877 5.07318C5.64598 4.43477 6.39153 3.9283 7.21255 3.5829C8.03357 3.23751 8.91382 3.05998 9.80281 3.06055Z",
    fill: "url(#paint1_linear_8381_67674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80284 16.781C9.68949 16.781 9.5768 16.781 9.46417 16.7718L9.36255 18.83C9.50862 18.8375 9.6554 18.8412 9.80284 18.8412C10.9585 18.8424 12.103 18.6123 13.1706 18.1638C14.2383 17.7154 15.2079 17.0576 16.024 16.2282L14.5862 14.769C13.9589 15.4071 13.2134 15.9133 12.3925 16.2586C11.5717 16.6038 10.6916 16.7814 9.80284 16.781Z",
    fill: "url(#paint2_linear_8381_67674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6185 4.25749L15.3299 2.97902C13.7656 1.69526 11.8129 0.996436 9.80005 1.00001V3.06028C11.1631 3.05857 12.4945 3.47603 13.6185 4.25749Z",
    fill: "url(#paint3_linear_8381_67674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.605 9.92064C18.6061 9.38468 18.5598 8.84964 18.4667 8.32202L16.5721 9.73709C16.5721 9.79808 16.5721 9.859 16.5721 9.92064C16.5726 10.8792 16.3743 11.8271 15.9902 12.703C15.606 13.5789 15.0445 14.3632 14.3422 15.0051L15.7087 16.5358C16.6219 15.7003 17.3516 14.6797 17.8505 13.5402C18.3495 12.4005 18.6065 11.1674 18.605 9.92064Z",
    fill: "#21A038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80282 16.7809C8.85694 16.7813 7.92154 16.5803 7.05716 16.191C6.19282 15.8017 5.41877 15.2327 4.78516 14.521L3.27551 15.9053C4.09978 16.8308 5.10679 17.5705 6.23127 18.0763C7.35574 18.582 8.57254 18.8426 9.80282 18.8412V16.7809Z",
    fill: "url(#paint4_linear_8381_67674)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.26352 4.83609L3.89765 3.30542C2.98423 4.14072 2.25426 5.16126 1.75507 6.30087C1.25589 7.44047 0.998639 8.67369 1.00001 9.92054H3.03361C3.03319 8.96207 3.23148 8.01412 3.61561 7.13823C3.99975 6.26237 4.56118 5.47804 5.26352 4.83609Z",
    fill: "url(#paint5_linear_8381_67674)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8381_67674",
    x1: 3.98958,
    y1: 15.9706,
    x2: 1.71435,
    y2: 9.48068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F1E813"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#C9DA26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#A2CC39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8381_67674",
    x1: 4.15888,
    y1: 3.97755,
    x2: 9.90077,
    y2: 1.81845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#0FA7DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0098F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0290EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8381_67674",
    x1: 9.22848,
    y1: 17.5978,
    x2: 15.708,
    y2: 16.1534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A2CC39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#86C239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#219F38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8381_67674",
    x1: 9.37705,
    y1: 1.69004,
    x2: 14.9224,
    y2: 3.37858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#0290EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#0C89CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8381_67674",
    x1: 3.78564,
    y1: 15.6545,
    x2: 9.8272,
    y2: 17.8824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F1E813"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EAE616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D8DF1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BAD52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#A2CC39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8381_67674",
    x1: 1.75759,
    y1: 10.1699,
    x2: 4.2317,
    y2: 3.81935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#A2CC39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#81C45E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0FA7DF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8381_67674"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSberIcon);
export default __webpack_public_path__ + "static/media/sber-icon.39ee3d0be7bc791690c4d99ebeadcfea.svg";
export { ForwardRef as ReactComponent };